import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_RECOMMENDATIONS } from "../domain";

import { recommendationsApi } from "@api/services";
import { roleGuard } from "@api";

const allowedRoles = [UserRole.Owner, UserRole.Manager, UserRole.Respondent];

const setRecommendationComplete = async (
  recommendationId: number,
): Promise<void> => {
  await recommendationsApi.recommendationsControllerSetRecommendationComplete(
    recommendationId,
  );
};

export const useSetRecommendationComplete = (
  user: UserProfileDto | null,
): {
  setRecommendationComplete: (recommendationId: number) => void;
  setRecommendationCompleteEnabled: boolean;
  isSuccessRecommendationComplete: boolean;
  isPendingRecommendationComplete: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_RECOMMENDATIONS],
    mutationFn: enabled ? setRecommendationComplete : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_RECOMMENDATIONS] });
    },
  });

  return {
    setRecommendationComplete: mutate,
    setRecommendationCompleteEnabled: enabled,
    isSuccessRecommendationComplete: isSuccess,
    isPendingRecommendationComplete: isPending,
  };
};
